export class Sizes {
    public static readonly dutyHeight: number = 45;
    public static readonly dutyWidths: number = 45;
    public static readonly personWidth: number = 100;
    public static readonly quarterWidth: number = 32;
    public static readonly consecutiveMonthsWidth: number = 35;
    public static readonly deltaWidth: number = 32;
    public static readonly summaryWidth: number = 32;
    public static readonly summaryWidthExtra: number = 5;
    public static readonly orderMarkWidth: number = 8;
    public static readonly longHaulLineHeight: number = 17;
    public static readonly scrollWidth: number = 17;
    public static readonly dutyPeriodHeight: number = 35;
    public static readonly historizedDutyHeight: number = Sizes.dutyHeight + 8;
    public static readonly datesHeight: number = 40;
    public static readonly gridVirtualSelectMinWidth: number = 180;
    public static readonly dutyListItemWidth: number = 40;
    public static readonly requestHeight: number = 20;
    public static readonly maxJeppesenImportFileSize: number = 1024 * 1024 * 50;
    public static readonly flightLineHeight: number = 30;
    public static readonly rotationHeight: number = 20;
    public static readonly actualRotationHeight: number = 3;
    public static readonly rotationBlockHeight: number = Sizes.rotationHeight + Sizes.actualRotationHeight;
}
